
<div mat-dialog-content class="w-full bg-white !p-0 !m-0">
  <div class="modal-title">
    <h3 class="green decoration">Confirmación</h3>
  </div>
  <div class="modal-inner">
    <p class="text-center" style="font-weight: 500;">{{ data.title }} </p>
  </div>
</div>

<div mat-dialog-actions class="!m-0 w-full block">
  <div class="w-full flex flex-wrap justify-center actions_modal">
        <!-- <button cdkFocusInitial mat-button class="!hidden">Autofocus disabled</button> -->
        <button mat-button type="button" (click)="dismiss()" class="btn btn-gray big">No, cancelar</button>
        <button mat-button type="button" (click)="closeModal()" class="btn btn-primary big">Si, continuar</button>
  </div>
</div>
